import { useLanguage } from '@/context/LanguageContext';

export default function Marquee() {
  const { t } = useLanguage();
  const items = t('marquee');
  return (
    <div className="relative border-y border-brand-line bg-white py-4 overflow-hidden mask-fade-x" data-testid="marquee">
      <div className="marquee-track animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={i} className="flex items-center gap-6 px-6 font-mono text-xs font-semibold uppercase tracking-widest text-brand-steel">
                {item}
                <svg width="10" height="10" viewBox="0 0 10 10" className="text-brand-blue"><rect x="2" y="2" width="6" height="6" rx="1" fill="currentColor" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
